module.exports = __webpack_public_path__ + "img/reticule2.3fa40252.jpg";